import { getCommonWidget } from "../dashWidgetHelper";
import { commonWidgets } from "./commonWidgetsGnp";

export default {
  title: 'General Dashboard',
  description: 'General de perfil Default',
  backgroundClassName: (filters) => 'epsilon-hero-bg',
  widgets: (filters: FiltersUI) => [
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'textAnalysis',
      position: [0, 0],
      size: [4, 4],
      indicator: 'SENTIMENT',
      criticalMomentInclude: [0, 29]
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'surveyResponsesTrend',
      position: [0, 4],
      size: [1, 2],
      indicator: 'SURVEY_COUNT',
      criticalMomentInclude: [0, 29]
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'wordCountWithLinks',
      title: 'Nube de Palabras / Frecuencia en comentarios',
      position: [1, 4],
      size: [3, 2],
      indicator: 'WORD_COUNT_WITH_LINKS',
      criticalMomentInclude: [0, 29],
      mapper: (data, extra) => {
        return data.map((item: any) => ({
          ...item,
          tags: item.tags.filter((tag: any) => tag.group !== 'DEFAULT')
        }))
      },
    }),
  ],
} as DasboardConfig
